import styled from 'styled-components/macro';
// import { motion } from 'framer-motion';
// import theme from '../../styles/GlobalTheme/schema.json';
import { defaultStyle } from '../../styles/GlobalTheme/GlobalStyles';
// import px2vw from '../../utils/px2vw';

export const Content = styled.p`
    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 28px;
    color: #0A2540;
`;